import {arrayMove} from "@dnd-kit/sortable";
import {SET_BOARD_LISTS} from "../store/constants";
import {API_URL, SOCKET} from "../URL";

export const handleDragEnd = async (event, visibleLists, dispatch, findListByCardId, updateCardSorts, boardId) => {
    const {active, over} = event;

    if (!over || active.id === over.id) return;

    const activeType = active?.data?.current?.type;
    const overType = over?.data?.current?.type;

    if (activeType === "list" && ["list", "card"].includes(overType)) {
        const activeListId = Number(String(active.id).replace("list-", ""));
        const overListId = overType === "card"
            ? findListByCardId(visibleLists, Number(String(over.id).replace("card-", "")))?.id
            : Number(String(over.id).replace("list-", ""));
        const sortableLists = visibleLists.filter((list) => !list.is_archive);

        const activeIndex = sortableLists.findIndex((item) => item.id === activeListId);
        const overIndex = sortableLists.findIndex((item) => item.id === overListId);

        if (activeIndex === -1 || overIndex === -1 || activeIndex === overIndex) return;

        const reorderedLists = arrayMove(sortableLists, activeIndex, overIndex).map(
            (item, index) => ({
                ...item,
                sort: index + 1,
            })
        );
        let visibleIndex = 0;
        const movedLists = visibleLists.map((list) =>
            list.is_archive ? list : reorderedLists[visibleIndex++]
        );

        dispatch({
            type: SET_BOARD_LISTS,
            payload: movedLists,
        });

        try {
            const response = await fetch(API_URL + "/post/move_list/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({newLists: reorderedLists.map(({id, sort}) => ({id, sort}))}),


            });
            if (!response.ok) throw new Error("Could not save the list order. Please try again.");

            SOCKET.emit("move_list", {
                board_id: boardId,
                lists: movedLists,
            });
        } catch (error) {
            dispatch({type: SET_BOARD_LISTS, payload: visibleLists});
            throw error;
        }

        return;
    }

    if (activeType === "card") {
        const activeCardId = Number(String(active.id).replace("card-", ""));
        const overIdStr = String(over.id);

        const sourceList = findListByCardId(visibleLists, activeCardId);
        if (!sourceList) return;

        let targetList = null;
        let targetCardId = null;

        if (overType === "card") {
            targetCardId = Number(overIdStr.replace("card-", ""));
            targetList = findListByCardId(visibleLists, targetCardId);
        } else if (overType === "list") {
            const overListId = Number(overIdStr.replace("list-", ""));
            targetList = visibleLists.find((list) => list.id === overListId);
        }

        if (!targetList) return;

        const sourceCards = [...(sourceList.cards || [])];
        const sourceIndex = sourceCards.findIndex((card) => card.id === activeCardId);

        if (sourceIndex === -1) return;

        const [movedCard] = sourceCards.splice(sourceIndex, 1);

        if (sourceList.id === targetList.id) {
            let targetIndex = sourceCards.length;

            if (targetCardId) {
                // Use the original index so moving down one position actually
                // places the card after the target, as the sortable preview does.
                targetIndex = sourceList.cards.findIndex((card) => card.id === targetCardId);
                if (targetIndex === -1) targetIndex = sourceCards.length;
            }

            sourceCards.splice(targetIndex, 0, movedCard);

            const reorderedCards = updateCardSorts(sourceCards);

            const updatedLists = visibleLists.map((list) =>
                list.id === sourceList.id
                    ? {...list, cards: reorderedCards}
                    : list
            );

            dispatch({
                type: SET_BOARD_LISTS,
                payload: updatedLists,
            });

            try {
                const response = await fetch(API_URL + "/post/move_card/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        source_list_id: sourceList.id,
                        target_list_id: targetList.id,
                        card_id: movedCard.id,
                        lists: updatedLists.map((list) => ({
                            id: list.id,
                            cards: (list.cards || []).map((card) => ({
                                id: card.id,
                                sort: card.sort,
                            })),
                        })),
                    }),
                });
                if (!response.ok) throw new Error("Could not save the card move. Please try again.");

                SOCKET.emit("move_card", {board_id: boardId, lists: updatedLists});
            } catch (error) {
                dispatch({type: SET_BOARD_LISTS, payload: visibleLists});
                throw error;
            }

            return;
        }

        const targetCards = [...(targetList.cards || [])];

        let targetIndex = targetCards.length;
        if (targetCardId) {
            targetIndex = targetCards.findIndex((card) => card.id === targetCardId);
            if (targetIndex === -1) targetIndex = targetCards.length;
        }

        targetCards.splice(targetIndex, 0, {
            ...movedCard,
            list_id: targetList.id,
        });

        const updatedLists = visibleLists.map((list) => {
            if (list.id === sourceList.id) {
                return {
                    ...list,
                    cards: updateCardSorts(sourceCards),
                };
            }

            if (list.id === targetList.id) {
                return {
                    ...list,
                    cards: updateCardSorts(targetCards),
                };
            }

            return list;
        });

        dispatch({
            type: SET_BOARD_LISTS,
            payload: updatedLists,
        });

        try {
            const response = await fetch(API_URL + "/post/move_card/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    source_list_id: sourceList.id,
                    target_list_id: targetList.id,
                    card_id: movedCard.id,
                    lists: updatedLists.map((list) => ({
                        id: list.id,
                        cards: (list.cards || []).map((card) => ({
                            id: card.id,
                            sort: card.sort,
                        })),
                    })),
                }),
            });

            if (!response.ok) throw new Error("Could not save the card move. Please try again.");

            SOCKET.emit("move_card", {
                board_id: boardId,
                lists: updatedLists
            });
        } catch (error) {
            dispatch({type: SET_BOARD_LISTS, payload: visibleLists});
            throw error;
        }
    }
};
